(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size24-editorial-body"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('s24-editorial-body')) {
    class Size24EditorialBody extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this._s24Mounted) this.mount();
        });
      }
      schoolDestination(value) {
        if (!value || !value.trim() || value.trim().startsWith('#')) return null;
        try {
          const url = new URL(value, window.location.href);
          return ['http:', 'https:'].includes(url.protocol) ? url : null;
        } catch (_) { return null; }
      }
      mount() {
        this._s24Mounted = true;
        this._s24Abort = new AbortController();
        const signal = this._s24Abort.signal;
        this.querySelectorAll('[data-s24-school]').forEach((panel) => {
          const picker = panel.querySelector('[data-s24-school-picker]');
          const select = panel.querySelector('[data-s24-school-select]');
          const button = panel.querySelector('[data-s24-school-go]');
          const fallback = panel.querySelector('[data-s24-school-fallback]');
          const status = panel.querySelector('[data-s24-school-status]');
          if (!picker || !select || !button) return;
          Array.from(select.options).forEach((option) => {
            if (option.value && !this.schoolDestination(option.value)) {
              option.disabled = true;
              option.hidden = true;
            }
          });
          const hasDestination = Array.from(select.options).some((option) => this.schoolDestination(option.value));
          if (!hasDestination) return;
          picker.hidden = false;
          if (fallback) fallback.hidden = true;
          const update = () => {
            button.disabled = !this.schoolDestination(select.value);
            if (status) status.textContent = '';
          };
          select.addEventListener('change', update, { signal });
          button.addEventListener('click', () => {
            const destination = this.schoolDestination(select.value);
            if (!destination) {
              button.disabled = true;
              if (status) status.textContent = 'Please select a school.';
              select.focus();
              return;
            }
            this.navigateToSchool(destination);
          }, { signal });
          update();
        });
      }
      navigateToSchool(destination) {
        window.location.assign(destination.href);
      }
      disconnectedCallback() {
        this._s24Abort?.abort();
        this._s24Mounted = false;
      }
    }
    customElements.define('s24-editorial-body', Size24EditorialBody);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size24-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('s24-editorial-hero')) {
    class Size24EditorialHero extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this._s24Mounted) this.mount();
        });
      }

      mount() {
        this._s24Mounted = true;
        this._s24Abort = new AbortController();
        this._s24Slides = Array.from(this.querySelectorAll('[data-s24-slide]'));
        this._s24Controls = this.querySelector('[data-s24-controls]');
        this._s24Counter = this.querySelector('[data-s24-counter]');
        this._s24Status = this.querySelector('[data-s24-status]');
        this._s24Index = Math.max(0, this._s24Slides.findIndex((slide) => !slide.hidden));
        const signal = this._s24Abort.signal;

        if (this._s24Controls) this._s24Controls.hidden = this._s24Slides.length < 2;
        this.querySelector('[data-s24-prev]')?.addEventListener('click', () => this.show(this._s24Index - 1, true), { signal });
        this.querySelector('[data-s24-next]')?.addEventListener('click', () => this.show(this._s24Index + 1, true), { signal });
        this._s24Controls?.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this._s24Index + (event.key === 'ArrowRight' ? 1 : -1), true);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.show(event.key === 'Home' ? 0 : this._s24Slides.length - 1, true);
          }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const blockId = String(event.detail?.blockId || '');
          const index = this._s24Slides.findIndex((slide) => slide.dataset.blockId === blockId);
          if (index >= 0) this.show(index, false);
        }, { signal });
        this.show(this._s24Index, false);
      }

      show(index, announce) {
        const slides = this._s24Slides || [];
        if (!slides.length) return;
        const nextIndex = ((index % slides.length) + slides.length) % slides.length;
        const outgoing = slides[this._s24Index];
        if (outgoing && this._s24Index !== nextIndex && outgoing.contains(document.activeElement)) {
          this.querySelector('[data-s24-next]')?.focus({ preventScroll: true });
        }
        this._s24Index = nextIndex;
        slides.forEach((slide, i) => {
          slide.hidden = i !== nextIndex;
          slide.setAttribute('aria-hidden', i === nextIndex ? 'false' : 'true');
        });
        const image = slides[nextIndex].querySelector('img');
        if (image) image.loading = 'eager';
        if (this._s24Counter) {
          this._s24Counter.textContent = `${String(nextIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        }
        if (announce && this._s24Status) this._s24Status.textContent = `Slide ${nextIndex + 1} of ${slides.length}`;
      }

      disconnectedCallback() {
        this._s24Abort?.abort();
        this._s24Mounted = false;
      }
    }
    customElements.define('s24-editorial-hero', Size24EditorialHero);
  }

  } catch(e) { console.error(e); }
})();
})();
